(function () {
  if (window.customElements.get('upsell-card')) {
    return;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + '€';
  }

  class UpsellCard extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('[data-upsell-data]');
      if (!dataEl) {
        return;
      }

      try {
        this.data = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      this.currentVariantId = Number(this.dataset.selectedVariant);
      this.selectedId = null;

      this.errorEl = this.querySelector('[data-upsell-error]');
      this.overlay = this.querySelector('[data-upsell-overlay]');
      this.sheet = this.querySelector('[data-upsell-sheet]');
      this.sheetAdd = this.querySelector('[data-upsell-sheet-add]');
      this.overlayAdd = this.querySelector('[data-upsell-overlay-add]');
      this.addButton = this.querySelector('[data-upsell-add]');
      this.overlayImage = this.querySelector('[data-upsell-overlay-image]');
      this.priceEls = Array.prototype.slice.call(this.querySelectorAll('[data-upsell-price]'));
      this.pills = Array.prototype.slice.call(this.querySelectorAll('[data-upsell-size]'));
      this.overlayThumbs = Array.prototype.slice.call(this.querySelectorAll('[data-upsell-overlay-thumb]'));

      this._onVariantChange = this._handleVariantChange.bind(this);
      document.addEventListener('variant:change', this._onVariantChange);

      if (this.data.singleVariant) {
        this.addButton.addEventListener('click', this._addToCart.bind(this));
        this.overlayAdd.addEventListener('click', this._addToCart.bind(this));
      } else {
        this.overlayAdd.addEventListener('click', this._switchToSheet.bind(this));
        this.sheetAdd.addEventListener('click', this._addToCart.bind(this));
      }

      this.overlayThumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          this.overlayImage.src = thumb.dataset.upsellOverlayThumb;
          this.overlayThumbs.forEach(function (other) {
            other.classList.toggle('is-active', other === thumb);
          });
        }.bind(this));
      }, this);

      this.pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.disabled) {
            return;
          }
          this.selectedId = Number(pill.dataset.upsellSize);
          this._update();
        }.bind(this));
      }, this);

      this._preselect();
      this._update();
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this._onVariantChange);
    }

    _currentSizeTitle() {
      var current = this.data.currentVariants.find(function (v) {
        return v.id === this.currentVariantId;
      }, this);
      return current ? current.title : null;
    }

    _preselect() {
      if (this.data.singleVariant || this.data.variants.length === 1) {
        this.selectedId = this.data.variants[0] ? this.data.variants[0].id : null;
        return;
      }

      var sizeTitle = this._currentSizeTitle();
      var match = sizeTitle ? this.data.variants.find(function (v) {
        return v.title === sizeTitle && v.available;
      }) : null;
      this.selectedId = match ? match.id : null;
    }

    _handleVariantChange(event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) {
        return;
      }
      var variantId = Number(variant.id);
      var belongsToProduct = this.data.currentVariants.some(function (v) {
        return v.id === variantId;
      });
      if (!belongsToProduct) {
        return;
      }
      this.currentVariantId = variantId;
      this._preselect();
      this._update();
    }

    _selected() {
      return this.data.variants.find(function (v) {
        return v.id === this.selectedId;
      }, this) || null;
    }

    _update() {
      var selected = this._selected();
      var priceSource = selected || this.data.variants.find(function (v) { return v.available; }) || this.data.variants[0];

      if (priceSource) {
        this.priceEls.forEach(function (el) {
          el.textContent = formatMoney(priceSource.price);
        });
      }

      this.pills.forEach(function (pill) {
        pill.classList.toggle('is-active', Number(pill.dataset.upsellSize) === this.selectedId);
      }, this);

      var ready = !!selected && selected.available;
      if (this.sheetAdd) {
        this.sheetAdd.disabled = !ready;
        this.sheetAdd.textContent = ready ? this.data.strings.addToCart : this.data.strings.chooseSize;
      }
      if (this.data.singleVariant) {
        this.addButton.disabled = !ready;
        this.overlayAdd.disabled = !ready;
      }
    }

    async _switchToSheet() {
      if (this.overlay && this.overlay.open) {
        await this.overlay.hide();
      }
      this.errorEl.hidden = true;
      this.sheet.show();
    }

    async _addToCart() {
      var selected = this._selected();
      if (!selected || !selected.available) {
        return;
      }

      var busyButtons = [this.sheetAdd, this.overlayAdd, this.addButton].filter(Boolean);
      this.errorEl.hidden = true;
      busyButtons.forEach(function (button) {
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
      });

      var sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } })
      );

      var payload = {
        items: [{ id: selected.id, quantity: 1 }],
        sections: sections.join(','),
        sections_url: window.location.pathname
      };

      try {
        var response = await fetch(Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload)
        });

        var responseJson = await response.json();

        if (!response.ok) {
          this.errorEl.textContent = responseJson.description || this.dataset.errorMessage || 'Error';
          this.errorEl.hidden = false;
          await this._closeAll();
          return;
        }

        var cart = await (await fetch(Shopify.routes.root + 'cart.js')).json();
        cart.sections = responseJson.sections;

        await this._closeAll();

        document.dispatchEvent(
          new CustomEvent('variant:add', {
            detail: {
              items: responseJson.items || [responseJson],
              cart: cart
            }
          })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cart
            }
          })
        );
      } catch (e) {
        this.errorEl.textContent = this.dataset.errorMessage || 'Error';
        this.errorEl.hidden = false;
        await this._closeAll();
      } finally {
        busyButtons.forEach(function (button) {
          button.removeAttribute('aria-busy');
        });
        this._update();
      }
    }

    async _closeAll() {
      if (this.sheet && this.sheet.open) {
        await this.sheet.hide();
      }
      if (this.overlay && this.overlay.open) {
        await this.overlay.hide();
      }
    }
  }

  window.customElements.define('upsell-card', UpsellCard);
})();
